import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import CloseDealModal from './modal/close_deal';
import { formatDate } from '../../helper';
import ImageClass from '../../assets';
import RenderIcons from '../reusable/render_icons';
import TransferDealModal from '../deal/modal/transfer_deal';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { AttachMoneyOutlined, CalendarMonthOutlined, EditOutlined, RepeatOutlined } from '@mui/icons-material';
import { Avatar, Box, Button, CircularProgress, Typography } from '@mui/material';
import { setEditDeal, setInitialDealStepValues } from '../../redux/slices/deal';
import { useDispatch, useSelector } from 'react-redux';

const DealInfoComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [transfer, setTransfer] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    const { selectedDealDetail, loaders } = useSelector((state: RootState) => state.deal);
    const { selectedPipeline } = useSelector((state: RootState) => state.pipeline);

    const editDealHandler = () => {
        dispatch(setInitialDealStepValues());
        dispatch(setEditDeal(true));
    };

    return (
        <CardWrapper>
            {loaders.isLoading
                ? <Box display="flex" alignItems="center" flexDirection="column" height="250px" justifyContent="center">
                    <CircularProgress />
                    <Typography variant="body2">Loading...</Typography>
                </Box>
                : <><Box display="flex" justifyContent="end" sx={{
                    '&:hover': {
                        cursor: 'pointer'
                    }
                }}>
                    <EditOutlined onClick={editDealHandler} />
                </Box>
                    <Box display="flex" justifyContent="center" my={2}>
                        <Avatar
                            src={selectedDealDetail?.profile_picture ? `${process.env.REACT_APP_FILE_PATH}${selectedDealDetail.profile_picture}` : ImageClass.userImage}
                            alt="User"
                            sx={{
                                height: '80px',
                                width: '80px',
                                border: `1px solid ${brand[300]}`
                            }}
                        />
                    </Box>
                    <Typography variant="body2" color="textsecondary" fontWeight="600" align="center" maxWidth="400px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                        {selectedDealDetail?.title}
                    </Typography>
                    <Box display="flex" justifyContent="center" gap="20px" my={2}>
                        <Box display="flex" gap="6px">
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: brand[50],
                                color: brand[300],
                                p: 1,
                                borderRadius: '5px'
                            }}>
                                <AttachMoneyOutlined />
                            </Box>
                            <Box>
                                <Typography variant="body2" color="textSecondary" fontWeight={600}>
                                    {selectedPipeline?.deal_default_value}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Deal Value
                                </Typography>
                            </Box>
                        </Box>
                        <Box display="flex" gap="6px">
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: brand[50],
                                color: brand[300],
                                p: 1,
                                borderRadius: '5px'
                            }}>
                                <CalendarMonthOutlined />
                            </Box>
                            <Box>
                                <Typography variant="body2" color="textSecondary" fontWeight={600}>
                                    {selectedDealDetail?.due_date ? formatDate(selectedDealDetail?.due_date as string) : '-'}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Due Date
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box borderTop="1px solid #ddd" pt={2}>
                        <Typography variant="body2" color="textSecondary" textTransform="uppercase">Details</Typography>
                        <Typography variant="body2" color="textSecondary" my={1} maxWidth="400px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap"><b>Email:</b> {selectedDealDetail?.email || '-'}</Typography>
                        <Typography variant="body2" color="textSecondary" ><b>Location:</b>
                            {!selectedDealDetail?.address && !selectedDealDetail?.city && !selectedDealDetail?.state && !selectedDealDetail?.zip && !selectedDealDetail?.country
                                ? '-'
                                : `${selectedDealDetail?.address || ''} ${selectedDealDetail?.city || ''}, ${selectedDealDetail?.state || ''} ${selectedDealDetail?.zip || ''} ${selectedDealDetail?.country || ''}`}
                        </Typography>
                    </Box>
                    <Box>
                        <RenderIcons contacts={selectedDealDetail?.prospect_result_meta || []} />
                    </Box>
                    <Box mt={2} display="flex" gap="10px" >
                        <Button variant="outlined" color="primary" fullWidth onClick={() => setTransfer(true)}>
                            <RepeatOutlined /> Transfer
                        </Button>
                        <Button variant="outlined" color="primary" fullWidth onClick={() => setShowModal(true)}>
                            {selectedDealDetail?.is_closed === 0 ? 'Close Deal' : 'Unclose Deal'}
                        </Button>
                    </Box></>}
            {transfer && <TransferDealModal open={transfer} onClose={() => setTransfer(false)} />}
            {showModal && <CloseDealModal open={showModal} onClose={() => setShowModal(false)} />}
        </CardWrapper>);
};

export default DealInfoComponent;